import { NgModule } from '@angular/core';
import { TabViewModule } from 'primeng/tabview';
import { CoreModule } from 'src/app/core/core.module';
import { GeneralModule } from '../general/general.module';
import * as Odonto from './odonto.components';

const COMPONENTS: any[] = [
  Odonto.SubjectComponent,
  Odonto.DiseaseComponent,
  Odonto.HistoryComponent,
  Odonto.HeaderComponent,
  Odonto.CatalogItemComponent,
  Odonto.StomatognathicComponent,
  Odonto.OdontogramComponent,
  Odonto.OralHealthComponent,
  Odonto.DiagnosticPlanComponent,
  Odonto.DiagnosticComponent,
  Odonto.TherapyComponent,
  Odonto.AdditionalInformationComponent,
  Odonto.WrapperComponent,
  Odonto.MainComponent,
  Odonto.TopBottomQuestionsComponent,
];

@NgModule({
  declarations: [...COMPONENTS],
  imports: [CoreModule, GeneralModule, TabViewModule],
  entryComponents: [],
  exports: [...COMPONENTS],
})
export class OdontologyModule {}
